import type { IconDef } from '../types';

export const finishFlag: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M22.9807 0.920685L2.00069 0.000685382C1.45069 -0.0193146 0.980685 0.400685 0.960685 0.960685L0.000685382 22.9407C-0.0193146 23.4907 0.400685 23.9607 0.960685 23.9807C1.51069 24.0007 1.98069 23.5807 2.00069 23.0207L2.42069 13.4907L22.4007 14.3607C22.9507 14.3807 23.4207 13.9607 23.4407 13.4007L23.9407 1.95069C23.9607 1.40069 23.5407 0.930685 22.9807 0.910685V0.920685ZM21.6807 7.72069V7.62069L16.9407 7.41069L16.7307 12.2407L11.9907 11.9107L12.2007 7.20069L7.45069 6.99068L7.25069 11.5707L2.51069 11.2407L2.71069 6.64069V6.78069L7.46069 6.99068L7.67069 2.12069L12.4707 2.46069H12.4107L12.2007 7.20069L16.9507 7.41069L17.1507 2.79069L22.0107 3.13069L21.6907 7.72069H21.6807Z',
    },
  ],
};
